import NP from "number-precision";
const number = NP;
export default number;
